import { useListsContext } from 'context/lists';
import { List, ListType } from 'crono-fe-common/types/list';
import useGetList from 'hooks/services/lists/useGetList';
import { useState } from 'react';

/**
 * The list a creation form adds the new records to. A list of another type
 * doesn't apply, e.g. a contacts list once the record must be a Lead.
 */
export const useListSelection = (listType: ListType) => {
  // Undefined until the user picks or clears a list.
  const [pickedList, setPickedList] = useState<List | null>();
  // The list being browsed, filled in until the user picks another one.
  const { currentListId } = useListsContext();
  const { data } = useGetList(currentListId);
  const browsedList = data?.data?.data;
  const autoFilledList = browsedList?.type === listType ? browsedList : null;

  const list = pickedList === undefined ? autoFilledList : pickedList;
  const selectedList = list?.type === listType ? list : null;

  return {
    selectedList,
    setSelectedList: setPickedList,
    /** The user picked another list than the one filled in by itself. */
    isDirty: (selectedList?.id ?? null) !== (autoFilledList?.id ?? null),
  };
};
